export default "__VITE_ASSET__BjCN32Cp__"